export { SectionTitle } from './SectionTitle';
export type { SectionTitleType } from './types';
